module.exports = __webpack_public_path__ + "img/appAsset-brand--Visa.36572556.svg";